import React from "react";
import Statistics from "../core/Statistics";
import {defaultSeason} from "../utils/time";

const ClubStatistics = ( {clubData} ) => {
 
  return (
    <Statistics
      mode={'club'}
      id={clubData.id}
      teams={clubData.teams}
      seasons={clubData.games_seasons}
    />
  );
}

export default ClubStatistics;